import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: 'accounts',
    children: [
      {
        name: 'accounts',
        path: '',
        component: () => import('../AccountsIndex.vue'),
      },
      {
        name: 'create-account',
        path: 'account',
        component: () => import('../AccountCreate.vue'),
      },

      {
        name: 'support-granted-accounts',
        path: 'support-granted',
        component: () => import('../SupportGrantedAccounts.vue'),
        meta: {
          isUserRoleOr: ['SUPPORT'],
          needsAccount: false,
        },
      },
    ],
  },
];
